import { ActionTypes } from '../constants/index';

export const faqs = (payload: any) => ({
  type: ActionTypes.FAQS_MGMT_LIST_REQUEST,
  payload,
});
